import { render, staticRenderFns } from "./PayFail.vue?vue&type=template&id=f1e1245a&scoped=true"
import script from "./PayFail.vue?vue&type=script&lang=js"
export * from "./PayFail.vue?vue&type=script&lang=js"
import style0 from "./PayFail.vue?vue&type=style&index=0&id=f1e1245a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e1245a",
  null
  
)

export default component.exports